__turbopack_context__.v({
  "chip": "Header-module-scss-module__HtywvW__chip",
  "chips-wrapper": "Header-module-scss-module__HtywvW__chips-wrapper",
  "chips-wrapper--expanded": "Header-module-scss-module__HtywvW__chips-wrapper--expanded",
  "header": "Header-module-scss-module__HtywvW__header",
  "header__extra": "Header-module-scss-module__HtywvW__header__extra",
  "toggle-button": "Header-module-scss-module__HtywvW__toggle-button",
  "toggle-button--rotate": "Header-module-scss-module__HtywvW__toggle-button--rotate",
  "wrapper": "Header-module-scss-module__HtywvW__wrapper",
});
